/**
 * Dashboard Page
 * Protected page for authenticated users - shows author dashboard
 */
import { Link } from "react-router-dom";
import { useAuth } from "../components/AuthProvider";

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">
        Welcome, {user?.name || "Author"}!
      </h1>
      <p className="text-slate-600">
        Your author dashboard is ready. Start creating novels and chapters.
      </p>

      {/* Dashboard cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Link
          to="/novels"
          className="bg-white rounded-lg border border-slate-200 p-6 hover:border-indigo-300 hover:shadow-md transition-all"
        >
          <h3 className="font-semibold text-slate-900 mb-2">Novels</h3>
          <p className="text-sm text-slate-600">
            Manage your novels and their settings.
          </p>
        </Link>
        <Link
          to="/novels"
          className="bg-white rounded-lg border border-slate-200 p-6 hover:border-indigo-300 hover:shadow-md transition-all"
        >
          <h3 className="font-semibold text-slate-900 mb-2">Chapters</h3>
          <p className="text-sm text-slate-600">
            Select a novel to write and publish chapters.
          </p>
        </Link>
        <Link
          to="/settings"
          className="bg-white rounded-lg border border-slate-200 p-6 hover:border-indigo-300 hover:shadow-md transition-all"
        >
          <h3 className="font-semibold text-slate-900 mb-2">Settings</h3>
          <p className="text-sm text-slate-600">
            Configure your author profile.
          </p>
        </Link>
      </div>
    </div>
  );
}
